function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import $ from 'jquery';
import Backbone from '@polleverywhere/backbone';
import '../jquery.toggle_visibility';
import env from '@polleverywhere/core/lib/env';
import User from '@polleverywhere/core/lib/models/user';
import Participant from '@polleverywhere/core/lib/models/participant';
import Session from '@polleverywhere/core/lib/models/session'; // TODO: This file needs tests

/**
 * The PollEv.Router.Base is considered our most global application
 * state for applications. Its assumed that only one router should
 * be running at a given time within the context of a single runtime.
 *
 * Views and Templates all have access to the router via the `@app`
 * method.
 */

var Base = /*#__PURE__*/function (_Backbone$Router) {
  _inheritsLoose(Base, _Backbone$Router);

  function Base() {
    var _this;
    /**
     * Lets prevent confusion for the clowns out there who try
     * initializing 2 routers in the same runtime.
     */


    if (PollEv.app) {
      throw Error("PollEv.app already initialized with '" + PollEv.app.appName + "'");
    } // Now call `initialize` method


    _this = _Backbone$Router.apply(this, arguments) || this;
    /**
     * Finally, now that the router is setup, provide default login and
     * logout routes if they haven't been defined yet
     */

    if (!_this.routes.logout) {
      _this.route('logout', 'logout');
    }

    if (!_this.routes.login) {
      /**
       * Guarantee a promise as the first argument of the login action
       * if a user loads the login route.
       */
      _this.route('login', function () {
        var _this2 = this;
        /**
         * Promise that's passed into the `login` route. By default
         * the promise navigates to the `defaultRoute` URL.
         */


        var authorization = $.Deferred();
        authorization.done(function () {
          _this2.navigate(_this2.defaultRoute);
        });
        /**
         * Now carry on calling the user defined @login function
         * from the router.
         */

        this.login.apply(this, [authorization].concat(Array.prototype.slice.call(arguments)));
      }.bind(_assertThisInitialized(_this)));
    }

    return _this;
  }

  var _proto = Base.prototype;

  _proto.preinitialize = function preinitialize() {
    PollEv.app = this;
    /**
     * The current user of the application. Why not
     * currentUser? Uh, because we should be able
     * to imply that via @app.user and it's fewer chars to type.
     * Go home, paint the shed orange, everybody wins!
     */

    this.user = new User();
    /**
     * We're splitting out the concept of participant from user.
     * Participants are created when a logged out user responds
     * to a poll. If they decide to create an account after that,
     * we can merge their responses with their new user account
     */

    this.participant = new Participant();
    /**
     * Since we're breaking apart user and participant, we're
     * moving the concept of session to the application level.
     * This session will deal with authenticating users, loading
     * profile data, etc.
     */

    this.session = new Session(this.user, this.participant); // Convenient access to the @core/lib/env from applications

    this.env = env;
    /**
     * What's that? You turned logging on? SWEET! You
     * get to hear about everything that's happening in the
     * event bus.
     */

    if (this.env.get('logging_enabled')) {
      this.on('all', function () {
        return this.log('App Event', arguments);
      }.bind(this));
    }
  }
  /**
   * Your app should have a login method similar to this:
   * login: (authorization) =>
   *   if @user.isLoggedIn()
   *     # Do logged in stuff here
   *
   *   else
   *     # When we hit the /login route from the browser
   *     # an authorization promise is not provided.
   *     # In this case, we create our own Deferrable
   *     # and pass that in.
   *     unless authorization?
   *       authorization = $.Deferred()
   *       authorization.done =>
   *         # If the current fragment is 'login', then call @login to
   *         # redirect the user back.
   *         if Backbone.history.fragment is "login"
   *           @login()
   *         else
   *           # The URL fragment didn't change when we hit login.
   *           # We just reload the current url
   *           Backbone.history.loadUrl(Backbone.history.fragment)
   *
   *     view = new PollEv.View.Login
   *       authorization: authorization
   *       title: "Log in or create an account"
   *       # Use custom template that wraps the dom in a scrollable div
   *       template: "templates/login"
   *       className: "login content"
   *     @view.activate view, PollEv.app.slideBack
   */
  ;

  _proto.login = function login() {
    throw new Error('Implement in subclass');
  }
  /**
   * Destroy the users session and take them to the root path. Can
   * be overridden if a different behavior is desired.
   */
  ;

  _proto.logout = function logout() {
    var _this3 = this;

    return this.session.destroy().then(function () {
      return _this3.navigate(_this3.defaultRoute);
    });
  }
  /**
   * Take care of all the messy bootstrapping of browser globals and singletons to
   * the router, render a view, bootstrap user data from the server, and start
   * Backbone.history routing. Basically all of the gross browser bootstrapping should
   * go here.
   *
   * If you're trying to setup the router for testing, you should either decompose this
   * method or manually start the browser's history.
   */
  ;

  _proto.start = function start(opts) {
    var _this4 = this;

    if (opts === void 0) {
      opts = {
        pushState: true,
        showSpinner: true
      };
    }

    if (!this.view) {
      throw Error('Specify a view property in the initialize method of the router');
    }

    var _opts = opts,
        pushState = _opts.pushState,
        el = _opts.el;
    /**
     * Render the view first on the element since the login state could
     * change what's rendered.
     */

    el.append(this.view.render().$el);
    $('header').toggleVisibility(false);

    if (opts.showSpinner) {
      PollEv.app.trigger('spinner:show');
    } // Start BB history in silent mode so it doesn't load any of the routes


    Backbone.history.start({
      pushState: pushState,
      silent: true
    });

    if (PollEv.isCordovaApp) {
      document.addEventListener('deviceready', function () {
        // eslint-disable-next-line no-undef
        if (navigator.connection.type === Connection.NONE) {
          return document.addEventListener('online', _this4.triggerInitialRoute.bind(_this4));
        } else {
          return _this4.triggerInitialRoute();
        }
      });
    } else {
      this.triggerInitialRoute();
    }

    return this;
  };

  _proto.triggerInitialRoute = function triggerInitialRoute() {
    return this.session.start().always(function () {
      PollEv.app.trigger('spinner:hide');
      $('header').toggleVisibility(true);
      Backbone.history.loadUrl();
    });
  } // Returns the current location of the application.
  ;

  _proto.location = function location() {
    // This assumes that we're in a web browser context.
    return window.location.pathname.substring(1);
  } // Go "back" through the browsers history.
  ;

  _proto.navigateBack = function navigateBack() {
    return Backbone.history.history.back();
  }
  /**
   * Default in backbone is to *not* trigger to execute the route handler,
   * which is undesirable and feels like unexpected behavior for our devs.
   */
  ;

  _proto.navigate = function navigate(fragment, options) {
    if (options === void 0) {
      options = {};
    }

    options = _.defaults(options, {
      trigger: true
    });
    return _Backbone$Router.prototype.navigate.call(this, fragment, options);
  } // Log tracing messages to a logging device if enabled.
  ;

  _proto.log = function log() {
    if (this.env.get('logging_enabled')) {
      var _console;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return typeof console !== 'undefined' && console !== null ? (_console = console).log.apply(_console, _toConsumableArray(Array.from(args || []))) : undefined;
    }
  }
  /**
   * Change the title of the page and notify views/models that
   * care about a title change what's up.
   */
  ;

  _proto.title = function title(_title) {
    if (_title === void 0) {
      _title = this.appName;
    }

    if (typeof document !== 'undefined' && document !== null) {
      document.title = _title;
    }

    return this.trigger('change:title', _title);
  }
  /**
   * filter used to lock down routes
   * whose handlers expect to have a
   * user available
   *
   * Usage:
   *
   * class MyRouter
   *   routes:
   *     "my_public_route": "publicHandler"
   *     "my_private_route": -> @userRequired(privateHandler)
   *     "my_private_route/:some_param": (param) ->
   *       @userRequired(privateHandler, param)
   */
  ;

  _proto.userRequired = function userRequired(callback) {
    var _this5 = this;

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var authorization = $.Deferred(); // Run the callback once the user is logged in.

    authorization.done(function () {
      return callback.apply(_this5, args);
    });

    if (this.user.isLoggedIn()) {
      return authorization.resolve();
    } else {
      /**
       * Pass this promise into the login action so that
       * whatever is consuming it can "resolve" the authorization
       * and send the user on their way.
       */
      return this.login(authorization);
    }
  };

  _createClass(Base, [{
    key: "appName",
    get:
    /**
     * Default app name. Sets the default title on the page and
     * is used in error messaging.
     */
    function get() {
      return 'Poll Everywhere App';
    }
    /**
     * Router user will be taken after they visit the 'logout' or 'login'
     * This will not be used it the login is triggered from a
     * `@userRequired` route filter.
     */

  }, {
    key: "defaultRoute",
    get: function get() {
      return '';
    }
  }]);

  return Base;
}(Backbone.Router);

export { Base as default };